interface TagProps {
  children: React.ReactNode;
  //   variant?: "default" | "primary" | "success" | "warning" | "danger";
}

export function Tag({ children }: TagProps) {
  return (
    <span className="bg-[#BF5000] py-2 px-4 font-semibold text-white rounded-sm text-[12px]">
      {children}
    </span>
  );
}
